import { toast } from "react-toastify";

// One failure usually produces TWO toasts: ApiService pushes a generic one from
// its own catch, then rejects, and the screen's catch pushes its own specific
// message. Both are wanted in isolation — a screen that does not toast still
// needs ApiService's — but they must never sit on screen together.
//
// Rather than touch all 229 files that raise toasts (55 call react-toastify
// directly, 174 go through components/ui), this hooks react-toastify's own
// onChange, which every source funnels through.
//
// The pair fires in the same tick (reject -> catch is a microtask), so this
// window only has to be long enough to cover a screen that awaits something
// before toasting. Kept short so two genuinely unrelated failures still both
// get seen.
const COLLAPSE_MS = 800;

let lastId = null;
let lastAt = 0;
let installed = false;

/**
 * Collapse rapid-fire toasts down to one. The NEWEST wins: ApiService toasts
 * first and the screen second, so what survives is the specific message
 * ("Invoiced Item cant be delete") rather than the generic fallback.
 */
export const installToastDedup = () => {
    if (installed) return;
    installed = true;

    toast.onChange((payload) => {
        if (payload?.status !== "added") return;

        const now = Date.now();
        if (lastId !== null && lastId !== payload.id && now - lastAt < COLLAPSE_MS) {
            toast.dismiss(lastId);
        }

        lastId = payload.id;
        lastAt = now;
    });
};

export default installToastDedup;
